import {shutdown} from '@intercom/messenger-js-sdk';
import posthog from 'posthog-js';

import {isWebViewApp, logOutWebView} from 'core/utils/webView';
import {getIsAzureAuth, getIsOktaAuth} from 'core/stores/auth';
import {oktaLogout, refreshOktaToken} from 'core/utils/auth/okta';
import {checkFeatureFlag} from 'core/hooks/authHooks';
import {FeatureFlags} from 'core/constants/featureFlags';

import {auth0Logout, refreshAuth0Token} from './auth0';
import {refreshAzureToken, azureLogout} from './azure';

export function logout() {
  if (checkFeatureFlag(FeatureFlags.Intercom)) {
    shutdown();
  }

  if (checkFeatureFlag(FeatureFlags.PostHog)) {
    // Clears identified user, super properties, and cached distinct_id so the
    // next login doesn't inherit the previous user's tenant/impersonation props.
    posthog.reset();
  }

  if (isWebViewApp()) {
    logOutWebView();
    return;
  }

  if (getIsAzureAuth()) {
    azureLogout();
    return;
  }

  if (getIsOktaAuth()) {
    oktaLogout();
    return;
  }

  auth0Logout();
}

export async function refreshAuthToken() {
  if (getIsAzureAuth()) {
    return refreshAzureToken();
  }

  if (getIsOktaAuth()) {
    return refreshOktaToken();
  }

  const auth0TokenResponse = await refreshAuth0Token();
  return auth0TokenResponse?.token;
}
